import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useSite } from "@/context/SiteContext";
import { mediaUrl } from "@/lib/api";

export default function Services() {
  const { services } = useSite();
  return (
    <main data-testid="services-page" className="bg-ivory text-ink pt-32 md:pt-40 pb-32">
      <section className="px-6 md:px-12 lg:px-16">
        <p className="label-mono opacity-60 line-badge">Services</p>
        <h1 className="mt-6 font-editorial text-6xl md:text-8xl leading-[0.95] max-w-4xl">
          Five bodies of <em className="italic">work</em>.
        </h1>
        <p className="mt-6 max-w-xl text-ink/70 text-lg">
          Choose your experience. Every service page carries its own packages, expectations and FAQs.
        </p>
      </section>

      <section className="px-6 md:px-12 lg:px-16 mt-20 space-y-24 md:space-y-40">
        {services.map((svc, i) => (
          <motion.article
            key={svc.slug}
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 1, ease: [0.19, 1, 0.22, 1] }}
            className="grid grid-cols-12 gap-6 md:gap-12 items-center"
          >
            <div className={`col-span-12 md:col-span-7 ${i % 2 === 1 ? "md:order-2" : ""}`}>
              <div className="photo-frame aspect-[4/3]">
                <img src={mediaUrl(svc.tile_image || svc.hero_image)} alt={svc.name} />
              </div>
            </div>
            <div className={`col-span-12 md:col-span-5 ${i % 2 === 1 ? "md:order-1" : ""}`}>
              <div className="flex items-baseline gap-4 mb-4">
                <span className="font-editorial text-5xl text-ink/30">0{i + 1}</span>
                <span className="label-mono opacity-60">{svc.short_name}</span>
              </div>
              <h2 className="font-editorial text-5xl md:text-6xl leading-[0.95]">
                {svc.name}
              </h2>
              <p className="mt-6 text-lg text-ink/70 max-w-md">{svc.intro}</p>
              <Link
                to={`/services/${svc.slug}`}
                className="btn-outline-ink mt-8"
                data-testid={`services-view-${svc.slug}`}
              >
                View Packages
              </Link>
            </div>
          </motion.article>
        ))}
      </section>
    </main>
  );
}
